import React, { useEffect, useState } from 'react'
import { Drawer } from 'antd'
import styled from 'styled-components'
import { useGetTaskDetail } from './utils'
import { SignTitle } from '@/components'
import { t } from '@/i18n'

interface PropsType {
  open: boolean
  onClose: () => void
  id: string
}

export interface DetailPropsType {
  //  客户端
  agent?: string
  //  安全域
  areaName?: string
  createTime?: string
  //  任务周期天数 每月/每周
  cycleDays: string[]
  //  任务id
  taskId?: string
  taskKind: string
  //  任务名称
  taskName?: string
  //  任务执行时间
  taskTime?: string
  templateName?: string
  verificationType?: string
}

const KindMap = {
  TaskKindDetailImmediately: t('立即'),
  TaskKindDetailBooking: t('预定'),
  TaskKindDetailCycleDay: t('每日'),
  TaskKindDetailCycleWeek: t('每周'),
  TaskKindDetailCycleMonth: t('每月'),
}

const WeekMap = {
  1: t('周一'),
  2: t('周二'),
  3: t('周三'),
  4: t('周四'),
  5: t('周五'),
  6: t('周六'),
  0: t('周日'),
}

const DetailDrawer: React.FC<PropsType> = ({ open, onClose, id }) => {
  const [getTaskDetail] = useGetTaskDetail()
  const [taskDetail, setTaskDetail] = useState<DetailPropsType>()

  const buildDetailData = data => {
    const detailObj = JSON.parse(JSON.stringify(data))

    detailObj.taskKind = KindMap[detailObj.taskKind]
    detailObj.cycleDays =
      detailObj.taskKind === t('每周')
        ? detailObj.cycleDays.split(',').map(item => WeekMap[item])
        : detailObj.cycleDays.split(',')

    return detailObj
  }

  useEffect(() => {
    if (!open) return
    getTaskDetail(id)
      .then(res => {
        setTaskDetail(buildDetailData(res.data))
      })
      .catch(_ => {})
  }, [open])

  return (
    <DrawerWrapper
      title={<SignTitle show>{t('任务详情')}</SignTitle>}
      width={480}
      open={open}
      onClose={onClose}
      footer={null}
    >
      <div className="task-config">
        <div className="title">
          <span>{t('任务配置')}</span>
        </div>
        <div className="content">
          <div className="item">
            <span className="label">{t('任务名称：')}</span>
            <span className="value">{taskDetail?.taskName}</span>
          </div>
          <div className="item">
            <div className="label">{t('任务ID：')}</div>
            <div className="value">{taskDetail?.taskId}</div>
          </div>
          <div className="item">
            <div className="label">{t('客户端：')}</div>
            <div className="value">{taskDetail?.agent === '()' ? '-' : taskDetail?.agent}</div>
          </div>
          <div className="item">
            <div className="label">{t('安全域：')}</div>
            <div className="value">{taskDetail?.areaName || '-'}</div>
          </div>
          <div className="item">
            <div className="label">{t('创建时间：')}</div>
            <div className="value">{taskDetail?.createTime}</div>
          </div>
          <div className="item special">
            <div className="label">{t('执行类型：')}</div>
            <div className="value">
              {taskDetail?.taskKind}
              &emsp;
              {taskDetail?.taskKind === t('每周') && (
                <div className="day-wrapper">
                  {taskDetail?.cycleDays?.map(day => (
                    <div key={day} className="day">
                      <span>{day}</span>
                      &emsp;
                      <span>{taskDetail?.taskTime}</span>
                    </div>
                  ))}
                </div>
              )}
              {taskDetail?.taskKind === t('每月') && (
                <div className="month-wrapper">
                  {taskDetail?.cycleDays?.map(day => (
                    <div key={day} className="day">
                      <span>
                        {day}
                        {t('号')}
                      </span>
                      &emsp;
                      <span>{taskDetail?.taskTime}</span>
                    </div>
                  ))}
                </div>
              )}
              &emsp;
              {![t('每周'), t('每月')].includes(taskDetail?.taskKind) && taskDetail?.taskTime}
            </div>
          </div>
        </div>
      </div>
      <div className="task-template">
        <div className="title">
          <span>{t('模板信息')}</span>
        </div>
        <div className="content">{taskDetail?.templateName}</div>
      </div>
    </DrawerWrapper>
  )
}

export default DetailDrawer

const DrawerWrapper = styled(Drawer)`
  .task-config {
    display: flex;
    flex-direction: column;

    .title {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 24px;
    }

    .content {
      display: flex;
      flex-direction: column;

      .item {
        margin-bottom: 20px;
        display: flex;

        &.special {
          min-height: 16px;
          max-height: 160px;
          overflow-y: scroll;
        }

        .label {
          min-width: 70px;
          color: #86909c;
          margin-right: 4px;
        }

        .value {
          height: 100%;
          color: #333333;
          display: flex;

          .day-wrapper,
          .month-wrapper {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            width: 120px;

            .day {
              display: flex;

              span {
                margin-bottom: 8px;

                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }
        }
      }
    }
  }

  .task-template {
    margin-top: 4px;
    display: flex;
    flex-direction: column;

    .title {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 16px;
    }

    .content {
      width: 432px;
      background: #f7f8fa;
      border-radius: 8px;
      padding: 12px;

      .item {
        margin-bottom: 16px;
        color: #666;
      }
    }
  }
`
